import React, {useContext} from 'react';
import {observer} from 'mobx-react-lite';
import {Main, Notification, TemplateHelp} from '../../../patterns';
import {StoreContext} from '../base/root-store';
import {ErrorBoundary} from '../base/ErrorBoundary';

export const SlackInstallPage = observer((): JSX.Element => {
    const store = useContext(StoreContext).companyStore;

    if (store.state === 'error') {
        return <ErrorBoundary>
            <Main showBackground={true}>
                <Notification
                    text={store.label('common.slack.error-message')}
                    defaultIsOpen={true}
                    type="error"
                />
            </Main>
        </ErrorBoundary>;
    } else if (store.variables.slackAuthSuccess === true) {
        return <ErrorBoundary>
            <Main showBackground={true}>
                <Notification
                    text={store.label('common.slack.completed-message')}
                    defaultIsOpen={true}
                    type="info"
                />
            </Main>
        </ErrorBoundary>;
    } else if (store.variables.slackAuthSuccess === false) {
        return <ErrorBoundary>
            <Main showBackground={true}>
                <Notification
                    text={store.label('common.slack.cancelled-message')}
                    defaultIsOpen={true}
                    type="info"
                    hasClickableUrl={true}
                />
            </Main>
        </ErrorBoundary>;
    } else {
        return <ErrorBoundary>
            <Main showBackground={true} isLoading={true}>
                <TemplateHelp/>
            </Main>
        </ErrorBoundary>;
    }
});
